import { Regions } from '@wicadu/langscope'

import globalTranslations from '@translations/pages/orders/orders-returns/global'

export const ORDERS_RETURNS_TRANSLATIONS = {
  [Regions.Global]: globalTranslations,
} as const
